const LoadingSpinner = ({ fullScreen = false, size = 'md' }) => {
  const sizeClasses = {
    sm: { width: '24px', height: '24px', border: '2px' },
    md: { width: '40px', height: '40px', border: '3px' },
    lg: { width: '60px', height: '60px', border: '4px' },
  };

  const styles = sizeClasses[size] || sizeClasses.md;

  if (fullScreen) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <div className="spinner" style={{ width: styles.width, height: styles.height, borderWidth: styles.border }}></div>
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center justify-content-center p-5">
      <div className="spinner" style={{ width: styles.width, height: styles.height, borderWidth: styles.border }}></div>
    </div>
  );
};

export default LoadingSpinner;
